import { defineComponent as _defineComponent } from 'vue'
import Avatar from '../../common/Avatar.vue';
import SvgIcon from '../../common/base/SvgIcon.vue';
import { isWeChat } from '../../../utils/environment';
import Dialog from '../../common/base/Dialog';
import '../../../directives/vTap';
import useMemberControlHooks from './useMemberControlHooks';
import { useI18n } from '../../../locales';
import { UserInfo } from '../../../stores/room';
import { roomService } from '../../../services';
import TuiInput from '../../common/base/Input';

interface Props {
  userInfo: UserInfo;
  showMemberControl: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberControlH5',
  props: {
    userInfo: null,
    showMemberControl: { type: Boolean }
  },
  emits: ['on-close-control'],
  setup(__props: any, { emit }) {

const props = __props as {
  userInfo: UserInfo;
  showMemberControl: boolean;
};



const { t } = useI18n();
const {
  controlList,
  handleCancelDialog,
  handleAction,
  isDialogVisible,
  dialogData,
  tempUserName,
  isShowInput,
  editorInputEleContainer,
  editorInputEle,
} = useMemberControlHooks(props);



function handleCloseControl() {
  isShowInput.value = false;
  emit('on-close-control');
}

function handleCloseInput(event: any) {
  if (isWeChat) {
    isShowInput.value = false;
  } else if (event.target !== event.currentTarget) {
    return;
  } else {
    isShowInput.value = false;
  }
}

return { __sfc: true,props, t, controlList, handleCancelDialog, handleAction, isDialogVisible, dialogData, tempUserName, isShowInput, editorInputEleContainer, editorInputEle, emit, handleCloseControl, handleCloseInput, Avatar, SvgIcon, isWeChat, Dialog, roomService, TuiInput }
}

})